import React, { useState } from "react";

export const Navigation: React.FC = () => {
  const [open, setOpen] = useState(false);
  const sections = [
    { id: "solucao", label: "Solução" },
    { id: "como-funciona", label: "Como funciona" },
    { id: "plataforma", label: "Plataforma" },
    { id: "personalizacao", label: "Personalização" },
    { id: "contato", label: "Contato" },
  ];

  return (
    <nav
      id="menu"
      className="fixed left-0 right-0 top-0 z-50 border-b border-slate-200/70 glass-panel"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 lg:px-8">
        <a
          href="#page-top"
          className="inline-flex items-center"
          aria-label="Sengia"
        >
          <img
            src="/img/sengia-logo-horizontal.png"
            alt="Sengia"
            className="h-10 w-44 object-contain object-left"
          />
        </a>

        {/* Menu desktop */}
        <ul className="hidden md:flex items-center space-x-6 text-sm font-medium text-slate-600">
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`} className="transition hover:text-blue-600">
                {section.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="/login"
              className="rounded-full bg-blue-600 px-5 py-2.5 text-white shadow-sm transition hover:bg-blue-700"
            >
              Entrar
            </a>
          </li>
        </ul>

        {/* Botão mobile */}
        <button
          className="md:hidden rounded-full border border-slate-200 bg-white/70 p-2 text-slate-700 shadow-sm"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menu"
          aria-expanded={open}
        >
          <span className="mb-1 block h-0.5 w-6 bg-slate-700"></span>
          <span className="mb-1 block h-0.5 w-6 bg-slate-700"></span>
          <span className="block h-0.5 w-6 bg-slate-700"></span>
        </button>
      </div>

      {/* Menu mobile */}
      {open && (
        <ul className="md:hidden bg-white/95 px-6 pb-6 pt-2 shadow-soft animate-fade-up space-y-3 text-sm font-medium text-slate-700">
          {sections.map((section) => (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                onClick={() => setOpen(false)}
                className="block rounded-lg px-3 py-2 transition hover:bg-slate-100"
              >
                {section.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="/login"
              onClick={() => setOpen(false)}
              className="block rounded-full bg-blue-600 px-4 py-2 text-center text-white"
            >
              Entrar
            </a>
          </li>
        </ul>
      )}
    </nav>
  );
};
